module.exports = __webpack_public_path__ + "img/apidays.3e4488d2.png";